import Enumeration from 'Lib/utilities/Enumeration';

const FieldTypes = new Enumeration([
    { id: 1, key: 'SingleLineText', name: 'Single Line Text' },
    { id: 2, key: 'Paragraph', name: 'Paragraph' },
    { id: 3, key: 'Dropdown', name: 'Dropdown' },
    { id: 4, key: 'Toggle', name: 'Toggle' },
    { id: 5, key: 'Date', name: 'Date' },
    { id: 6, key: 'Numeric', name: 'Numeric' },
    { id: 7, key: 'Currency', name: 'Currency' },
    { id: 8, key: 'WholeNumber', name: 'Whole Number' }
]);

export default FieldTypes;
